const columnRss = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'set-column-rss'
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default columnRss
